import { motion, AnimatePresence } from "framer-motion";
import { Sparkles } from "lucide-react";

export const ALIGN_MESSAGES = {
  up: "You have risen from the Heart of Earth to 7th Heaven",
  down: "You have grounded 7th Heaven to the Heart of Earth",
};

export const AlignmentComplete = ({ show, direction = "up", onDismiss }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        className="absolute inset-0 z-30 flex flex-col items-center justify-center text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onDismiss}
        data-testid="alignment-complete"
      >
        <motion.div
          aria-hidden
          className="absolute rounded-full"
          style={{
            width: 420,
            height: 420,
            background:
              "radial-gradient(circle, rgba(255,45,85,0.35), rgba(255,204,0,0.3) 30%, rgba(52,199,89,0.3) 50%, rgba(90,200,250,0.3) 70%, rgba(199,125,255,0.35) 90%, rgba(3,3,8,0) 100%)",
            filter: "blur(10px)",
          }}
          initial={{ scale: 0.3, opacity: 0 }}
          animate={{ scale: [0.3, 1.15, 1], opacity: [0, 1, 0.9] }}
          transition={{ duration: 2.2, ease: "easeOut" }}
        />
        <motion.div
          className="relative z-10 flex flex-col items-center gap-3 rounded-3xl bg-slate-950/55 px-6 py-5 backdrop-blur-sm"
          style={{ textShadow: "0 0 14px rgba(0,0,0,0.9), 0 0 4px rgba(0,0,0,0.8)" }}
          initial={{ y: 16, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.5, duration: 1 }}
        >
          <Sparkles className="text-amber-200" size={30} />
          <p className="font-serif text-4xl text-white drop-shadow-[0_0_25px_rgba(255,255,255,0.4)]">
            Alignment Complete.
          </p>
          <p className="max-w-md font-serif text-lg italic text-slate-200" data-testid="alignment-message">
            {ALIGN_MESSAGES[direction]}
          </p>
          <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-cyan-200/90">tap to dismiss</p>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
